(function() {
  'use strict';

  var header = document.querySelector('.custom-header');
  if (!header) return;
  var section = header.closest('.shopify-section');
  if (!section) return;

  var toggle = section.querySelector('.custom-header__menu-toggle');
  var drawer = section.querySelector('.custom-header__drawer');
  var backdrop = section.querySelector('.custom-header__drawer-backdrop');

  if (!toggle || !drawer) return;

  /* Track teardown so section-reload in the editor doesn't leak listeners. */
  var teardown = [];
  function on(target, event, handler, opts) {
    target.addEventListener(event, handler, opts);
    teardown.push(function() { target.removeEventListener(event, handler, opts); });
  }

  /* Scroll lock is handled centrally in layout/theme.liquid via a :has()
     rule that watches for `.custom-header__drawer[aria-hidden="false"]`
     and sets overflow:hidden on <html>+<body>. No JS work needed here. */

  /* Focus trap inside the drawer */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trap(e) {
    if (e.key !== 'Tab') return;
    var nodes = drawer.querySelectorAll(FOCUSABLE);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var lastFocused = null;
  function openDrawer() {
    lastFocused = document.activeElement;
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    var firstLink = drawer.querySelector(FOCUSABLE);
    if (firstLink) firstLink.focus();
  }

  function closeDrawer() {
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  on(toggle, 'click', function() {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    if (isOpen) closeDrawer(); else openDrawer();
  });

  /* Dedicated close button inside the drawer top bar */
  var drawerCloseBtn = section.querySelector('[data-drawer-close]');
  if (drawerCloseBtn) on(drawerCloseBtn, 'click', closeDrawer);

  if (backdrop) on(backdrop, 'click', closeDrawer);

  on(drawer, 'keydown', trap);

  on(document, 'keydown', function(e) {
    if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeDrawer();
  });

  /* Close desktop <details> dropdowns on outside click */
  on(document, 'click', function(e) {
    var dropdowns = section.querySelectorAll('.custom-header__dropdown');
    dropdowns.forEach(function(dropdown) {
      if (!dropdown.contains(e.target) && dropdown.open) dropdown.open = false;
    });
  });

  /* Esc closes any open desktop dropdown (mega or plain) */
  on(document, 'keydown', function(e) {
    if (e.key !== 'Escape') return;
    var openDropdown = section.querySelector('.custom-header__dropdown[open]');
    if (openDropdown) {
      openDropdown.open = false;
      var summary = openDropdown.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  /* Auto-submit localization form on currency change (topbar flag
     picker). */
  var locForms = section.querySelectorAll('.custom-header__drawer-topbar-loc');
  locForms.forEach(function(locForm) {
    var locSelect = locForm.querySelector('select');
    if (locSelect) on(locSelect, 'change', function() { locForm.submit(); });
  });

  /* Hover-intent for mega menus (desktop pointer devices only).
     80ms open delay debounces sweep-through; 150ms close delay
     gives a forgiving grace zone when moving diagonally into the panel. */
  var hoverEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var megaDropdowns = section.querySelectorAll('.custom-header__dropdown--mega');
  megaDropdowns.forEach(function(dd) {
    var openTimer = null;
    var closeTimer = null;
    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    if (hoverEnabled) {
      on(dd, 'mouseenter', function() {
        clearTimers();
        openTimer = setTimeout(function() { dd.open = true; }, 80);
      });
      on(dd, 'mouseleave', function() {
        clearTimers();
        closeTimer = setTimeout(function() { dd.open = false; }, 150);
      });
    }

    /* Keyboard: open when summary or any descendant gets focus,
       close when focus leaves the entire dropdown. */
    on(dd, 'focusin', function() {
      clearTimers();
      dd.open = true;
    });
    on(dd, 'focusout', function(e) {
      if (dd.contains(e.relatedTarget)) return;
      clearTimers();
      closeTimer = setTimeout(function() { dd.open = false; }, 150);
    });
  });

  /* ── Announcement bar show/hide on scroll direction (rAF throttled) ── */
  var announcementSection = document.querySelector('.custom-announcement-bar-section');
  if (announcementSection) {
    var lastScrollY = window.scrollY;
    var scrollUpAccum = 0, scrollDownAccum = 0;
    var isHidden = false;
    var deadZone = 3;
    var scrollPending = false;

    function processScroll() {
      scrollPending = false;
      var currentScrollY = window.scrollY;
      var delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      if (Math.abs(delta) < deadZone) return;

      var isMobile = window.innerWidth < 750;
      var showThreshold = isMobile ? 240 : 120;
      var hideThreshold = isMobile ? 100 : 200;

      if (delta > 0) {
        scrollUpAccum = 0;
        scrollDownAccum += delta;
        if (scrollDownAccum >= hideThreshold && !isHidden) {
          announcementSection.classList.add('is-hidden');
          isHidden = true;
          scrollDownAccum = 0;
        }
      } else {
        scrollDownAccum = 0;
        scrollUpAccum += Math.abs(delta);
        if (scrollUpAccum >= showThreshold && isHidden) {
          announcementSection.classList.remove('is-hidden');
          isHidden = false;
          scrollUpAccum = 0;
        }
      }

      if (currentScrollY <= 10 && isHidden) {
        announcementSection.classList.remove('is-hidden');
        isHidden = false;
        scrollUpAccum = 0;
        scrollDownAccum = 0;
      }
    }

    on(window, 'scroll', function() {
      if (scrollPending) return;
      scrollPending = true;
      window.requestAnimationFrame(processScroll);
    }, { passive: true });
  }

  /* Cleanup on section unload (Theme Editor re-renders) */
  document.addEventListener('shopify:section:unload', function(e) {
    if (!section || !e.target || !e.target.contains(section)) return;
    if (toggle.getAttribute('aria-expanded') === 'true') closeDrawer();
    teardown.forEach(function(fn) { try { fn(); } catch (err) {} });
    teardown.length = 0;
  }, { once: true });

})();
